import EInvoiceDetail from "./EInvoiceDetail.vue";

export default EInvoiceDetail